import React, { useEffect, useState } from 'react';
import { isProdBuild, buildUrlEnding } from '../../i18n/environments';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';

type Iprops = {
  id?: string;
  src: string;
  alt: string;
  width?: string;
  height?: string;
  loading?: 'eager' | 'lazy';
  decoding?: 'auto' | 'async' | 'sync';
  className?: string;
  data?: string;
  easing?: string;
  delay?: string;
  style?: {};
  onClick?: () => void;
  isSliderComponent?: boolean;
};

const CloudflareImage = ({
  id,
  src,
  alt,
  width,
  height,
  loading = 'eager',
  decoding,
  className,
  data,
  easing,
  delay,
  style,
  onClick,
  isSliderComponent = false,
}: Iprops) => {
  const [imageQuality, setImageQuality] = useState(90);
  const [imageWidth, setImageWidth] = useState<string | number>(width);
  const intrinsicImageWidth = width !== 'auto' && Number(width) < 100 ? Number(width) * 1.5 : imageWidth;
  const [error, setError] = useState(false);
  const { isEs } = useCurrentLanguage();

  useEffect(() => {
    if (isProdBuild) {
      const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (!width) {
        setImageWidth('auto');
      }

      if (deviceWidth < +imageWidth) {
        setImageWidth(deviceWidth);
      }

      if (deviceWidth < 968) {
        setImageQuality(80);
      }
    }
  }, [src]);

  const handleOnError = () => {
    setError(true);
    if (isProdBuild) {
      console.warn(`Asset {${src}} could not be loaded from CloudFlare.`);
    }
  };

  return isSliderComponent ? (
    <img
      id={id}
      alt={alt}
      className={className}
      data-aos-delay={delay}
      data-aos-easing={easing}
      data-aos={data}
      decoding={decoding}
      height={height}
      loading={loading}
      onClick={onClick}
      src={`${
        !!error && isProdBuild
          ? `https://www.zerobounce${buildUrlEnding}/cdn-cgi/image/fit=scale-down,format=auto,quality=${imageQuality},width=${intrinsicImageWidth},metadata=none${src}`
          : `${src}`
      }`}
      onError={handleOnError}
      style={style}
      width={imageWidth}
    />
  ) : (
    <LazyLoadImage
      id={id}
      alt={alt ? alt : isEs ? 'ZeroBounce Imagen' : 'ZeroBounce Image'}
      visibleByDefault
      className={className}
      data-aos-delay={delay}
      data-aos-easing={easing}
      data-aos={data}
      decoding={decoding}
      height={height}
      loading={loading}
      onClick={onClick}
      src={`${
        !error && isProdBuild
          ? `https://www.zerobounce${buildUrlEnding}/cdn-cgi/image/fit=scale-down,format=auto,quality=${imageQuality},width=${intrinsicImageWidth},metadata=none${src}`
          : `${src}`
      }`}
      onError={handleOnError}
      style={style}
      width={imageWidth}
    />
  );
};

export default CloudflareImage;
